// @ts-nocheck
import React from 'react';
import recruitlookHoopsLogo from '@/assets/recruitlook-hoops-logo.jpeg';

const MediaPolicy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="prose prose-lg max-w-none">
        <h1 className="text-4xl font-heading font-bold text-gray-900 mb-8">
          RecruitLook Hoops Outside Media Policy
        </h1>

        <h2 className="text-2xl font-heading font-bold text-gray-900 mt-12 mb-4">Overview</h2>
        <p className="text-gray-700 leading-relaxed mb-6">
          All RecruitLook events are private and credentialed. Any outside photographer or videographer granted media access agrees to comply fully with the following policy as a condition of entry.
        </p>

        <h2 className="text-2xl font-heading font-bold text-gray-900 mt-12 mb-4">
          Media Access & Submission Requirement
        </h2>
        <p className="text-gray-700 leading-relaxed mb-6">
          Media access to RecruitLook events is granted in exchange for full media submission.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          All approved outside media must upload the following from each RecruitLook event they cover:
        </p>
        <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
          <li>100% of raw photo files</li>
          <li>100% of raw video clips</li>
          <li>Any edited content created from the event</li>
        </ul>

        <h3 className="text-xl font-heading font-semibold text-gray-900 mt-8 mb-3">
          Submission Deadlines
        </h3>
        <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
          <li><strong>Raw files:</strong> Due within 24 hours of the event</li>
          <li><strong>Edited content:</strong> Due within 48 hours of the event</li>
        </ul>
        <p className="text-gray-700 leading-relaxed mb-6">
          All files must be uploaded to RecruitLook's official Google Drive, as directed by RecruitLook staff.
        </p>

        <h2 className="text-2xl font-heading font-bold text-gray-900 mt-12 mb-4">
          Rights & Usage
        </h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          The outside media creator retains ownership of all content.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          RecruitLook is granted a non-exclusive, royalty-free license to use the submitted content for:
        </p>
        <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
          <li>Social media</li>
          <li>Website and digital platforms</li>
          <li>Marketing and promotional materials</li>
          <li>Sponsor activations</li>
          <li>Internal archives</li>
        </ul>
        <p className="text-gray-700 leading-relaxed mb-6">
          RecruitLook may edit, brand, distribute, and share content with athletes, teams, partners, and affiliates.
        </p>

        <h2 className="text-2xl font-heading font-bold text-gray-900 mt-12 mb-4">
          Posting & Distribution Rules
        </h2>
        <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
          <li>
            Outside media may post their own content only after RecruitLook has posted first, unless prior approval is granted.
          </li>
          <li>
            All posts must tag RecruitLook social media accounts:{" "}
            <a href="https://x.com/RL_Hoops" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Boys HS X</a> |{" "}
            <a href="https://x.com/RL_HoopsNextUP" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Boys Juniors X</a> |{" "}
            <a href="https://x.com/RL_HoopsGirls" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Girls X</a> |{" "}
            <a href="https://www.instagram.com/recruit_look/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">RecruitLook Instagram</a>
          </li>
          <li>Content may not be sold, licensed, or distributed to third parties.</li>
          <li>
            Outside media may not claim official partnership, affiliation, or endorsement with RecruitLook.
          </li>
          <li>
            Outside media may not, under any circumstances, contract with teams to collaborate on paid video work. Any potential pay-for-hire opportunities need to go through RecruitLook.
          </li>
        </ul>

        <h2 className="text-2xl font-heading font-bold text-gray-900 mt-12 mb-4">
          Enforcement
        </h2>
        <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
          <li>
            Failure to submit all required media within the stated deadlines will result in loss of future media access.
          </li>
          <li>
            RecruitLook reserves the right to deny, limit, or revoke media credentials at any time, with or without cause.
          </li>
        </ul>

        <h2 className="text-2xl font-heading font-bold text-gray-900 mt-12 mb-4">
          RecruitLook Logo & Placement
        </h2>
        <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
          <li>All media files must include the RecruitLook Hoops logo.</li>
          <li>Place the RecruitLook Hoops logo in the bottom left corner of all pictures and videos.</li>
        </ul>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-600 mb-4 text-sm">
            Right-click and save the logo below for use in your media:
          </p>
          <img 
            src={recruitlookHoopsLogo} 
            alt="RecruitLook Hoops Logo" 
            className="max-w-[200px] h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default MediaPolicy;
